import React, { useContext } from 'react'
import edit from '../images/Icon-Edit.svg'
import { keyContext } from './KeyContext';

function Visuals({data}) {
  // console.log(data)
 const { setVisualDivHeight,visualDivHeight} = useContext(keyContext)
  // following function will capitalize the first letter 
  function capitalize(s){
               return s && String(s[0]).toUpperCase() + String(s).slice(1);
        }

         //-------------function for checking empty array----------
function isEmpty(obj) {
  for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
          return false;
      }
  }
  return true; 
}

setVisualDivHeight(document.getElementById('film').getBoundingClientRect().height)
// console.log(visualDivHeight, 'visualDivHeight')
  return (
    <section style={{display:'flex',justifyContent:'space-between',flexWrap:'wrap'}}>
      { isEmpty(data.hDPath) === false ?
       <div className='visualContainer'> 
             <div style={{position:'relative'}}>
                <img style={{width:'241px'}} src={`https://ebillet.dk/poster/`+data.hDPath}  alt="" />
                {/* <img src={edit} alt="" style={{position:'absolute',right:'0px'}}/> */}
             </div>
             <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Poster</p>
              <p style={{fontWeight:400,marginTop:'-4px'}}>{isEmpty(data.hDPath) === false ? capitalize(data.hDPath) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>1080 x 1600 px</p>
             </div>
       </div>
        : null}
         { isEmpty(data.largePath) === false ?
       <div className='visualContainer'> 
             <div style={{position:'relative'}}>
                <img style={{width:'177px'}} src={`https://ebillet.dk/poster/`+data.largePath}  alt="" />
                {/* <img src={edit} alt="" style={{position:'absolute',right:'0px'}}/> */}
             </div>
             <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Poster</p>
              <p style={{fontWeight:400,marginTop:'-4px'}}>{isEmpty(data.largePath) === false ? capitalize(data.largePath) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>350 x 519 px</p>
             </div>
       </div>
        : null}
         { isEmpty(data.path) === false ?
       <div className='visualContainer'> 
             <div style={{position:'relative'}}>
                <img style={{width:'107px'}} src={`https://ebillet.dk/poster/`+data.path}  alt="" />
                {/* <img src={edit} alt="" style={{position:'absolute',right:'0px'}}/> */}
             </div>
             <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Poster</p>
              <p style={{fontWeight:400,marginTop:'-4px'}}>{isEmpty(data.path) === false ? capitalize(data.path) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>150x 222 px</p>
             </div>
       </div>
        : null}
         { isEmpty(data.livePoster) === false ?
       <div className='visualContainer' style={{marginTop:'50px',height:'571px'}}> 
             <div style={{position:'relative',top:0,display:'flex'}}>
              <div style ={{width:'242px'}}>
               <video  controls 
                 style={{width:'100%'}} >
                 <source src={`https://ebillet.dk/liveposter/${data.livePoster}`} type="video/mp4" />
             </video> 
             </div>
             </div>
             <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Levende plakat (filmformat):</p>
              <p style={{fontWeight:400,marginTop:'-4px'}}>{isEmpty(data.livePoster) === false ? capitalize(data.livePoster) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>1080 x 1920 px</p>
             </div>
       </div>
        : null}
   </section>
  )
}

export default Visuals